export default __webpack_public_path__ + "static/dabrowskiego-023acd0c58c80adaf88fb58bd26d8b02.png";